import React from "react";
import style from "./errorscreen.module.css";
import oops from "../../assets/Images/oops.png";
import { Link } from "react-router-dom";

export const ErrorScreen = ({ scourceImage = oops }) => {
  return (
    <div className={style.container}>
      <div className={style.content}>
        <img src={scourceImage} className={style.image} alt="not Found" />
      </div>
      <div className="cornerBtnStyle">
        <Link to="/" className="text-white">
          <button className="basicBtnStyle secondaryBtn ml-5 mt-3">Home</button>
        </Link>
      </div>
    </div>
  );
};
